import DocumentoRevocacion from "./DocumentoRevocacion";

class ParametroRevocarAutorizacion {
  constructor() {
    this.NumeroAutorizacion = "";
    this.TipoAutorizacion = 0;
    this.Documentos = [];
  }

  NumeroAutorizacion: string;
  TipoAutorizacion: number;
  Documentos: DocumentoRevocacion[];
}
export default ParametroRevocarAutorizacion;
